import "/tmp/build_cf856e8e/vendor/bundle/ruby/2.7.0/gems/cocoon-1.2.15/app/assets/javascripts/cocoon";
